import React from "react";
import { ReactComponent as Icono } from "../../assets/posicionMapa.svg"

export default function Horizonte(props) {
  const { angle } = props;
  const screenWidth = window.innerWidth;

  const normalizeAngle = (angle) => {
    let a = angle % 360;
    if (a > 180) a -= 360;
    if (a < -180) a += 360;
    return a;
  };

  const normalized = normalizeAngle(angle);
  const xFactor = normalized / 90;
  const clamped = Math.max(-1, Math.min(1, xFactor));
  const distance = Math.abs(clamped);
  const scale = 1 + distance;
  const red = Math.floor(255 * distance);
  const green = Math.floor(255 * (1 - distance));
  const color = `rgb(${red}, ${green}, 0)`;

  const iconWidth = 60; // en px (o calculado)
  const margin = iconWidth / 2;

  const usableWidth = screenWidth - margin * 2;
  const x = margin + (usableWidth / 2) + clamped * (usableWidth / 2);

  return (
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: x,
        transform: `translate(-50%, -50%) scale(${scale})`,
        transition: "left 0.1s linear, transform 0.1s linear",
      }}
    >
      <Icono
        style={{
          width: "3.2vw",
          height: "8vh",
          color: color, // 🔥 ahora sí funciona
          filter: `drop-shadow(0 0 8px ${color})`
        }}
      />
    </div>
  );
};